// extracted by mini-css-extract-plugin
module.exports = {"infoIconStyle":"Transactions_infoIconStyle__ML1JE"};